module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Row', {
    staticClass: "igo"
  }, [_c('navbar', {
    attrs: {
      "transparent": _vm.isTransparent,
      "activeTo": "/Services"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "igo-product-banner"
  }, [_c('div', {
    staticClass: "igo-product-banner-bg"
  }, [_c('div', {
    staticClass: "igo-product-banner-page"
  }, [_c('h1', {
    staticClass: "banner-title"
  }, [_vm._v(_vm._s(_vm.$t('cable_details_page_banner_title')))]), _vm._v(" "), _c('p', {
    staticClass: "banner-content"
  }, [_vm._v(_vm._s(_vm.$t('cable_details_page_banner_sm_title')))])])])]), _vm._v(" "), _c('section', {
    staticClass: "igo-product-page"
  }, [_c('div', {
    staticClass: "igo-product-buy-page"
  }, [_c('i-col', {
    staticClass: "igo-product-buy-page-img",
    attrs: {
      "lg": 13,
      "md": 13,
      "sm": 24,
      "xs": 24
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/igo/cable_1.png"),
      "width": "75%"
    }
  })]), _vm._v(" "), _c('i-col', {
    staticClass: "igo-product-buy-page-dail",
    attrs: {
      "lg": 11,
      "md": 11,
      "sm": 24,
      "xs": 24
    }
  }, [_c('div', {
    staticClass: "igo-product-buy-page-title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('cable_details_page_banner_title')))])]), _vm._v(" "), _c('div', {
    staticClass: "igo-product-buy-page-price"
  }, [_c('p', [_vm._v("$" + _vm._s(_vm.goods_info.goods_price))])]), _vm._v(" "), _c('div', {
    staticClass: "igo-product-buy-page-details"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('cable_details_page_product_content')))])]), _vm._v(" "), _c('buy', {
    attrs: {
      "id": parseInt(_vm.$route.query.id),
      "maxCount": parseInt(_vm.goods_info.store_count)
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "igo-product-details"
  }, [_c('div', {
    staticClass: "igo-product-details-page max_width"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('cable_details_page_advantage1')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('cable_details_page_advantage1_content')))]), _vm._v(" "), _c('div', {
    staticClass: "igo-product-details-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/igo/cable_bg_2.png"),
      "width": "82%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ios-description"
  }, [_vm._v(_vm._s(_vm.$t('cable_details_page_advantage1_content1')))]), _vm._v(" "), _c('p', {
    staticClass: "android-description"
  }, [_vm._v(_vm._s(_vm.$t('cable_details_page_advantage1_content2')))])])]), _vm._v(" "), _c('div', {
    staticClass: "igo-product-details-page",
    staticStyle: {
      "background": "#FFFFFF"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('cable_details_page_advantage2')))]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.$t('cable_details_page_advantage2_content')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('cable_details_page_advantage2_content1')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('cable_details_page_advantage2_content2')))])]), _vm._v(" "), _c('img', {
    staticClass: "cable-img-1",
    attrs: {
      "src": require("../../../assets/igo/cable_bg_3.jpg"),
      "width": "50%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "igo-product-details-page",
    staticStyle: {
      "background": "#FFFFFF"
    }
  }, [_c('div', {
    staticClass: "igo-product-details-page-tip"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/igo/icon_1.png")
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('cable_details_page_advantage3'))), _c('br'), _vm._v(_vm._s(_vm.$t('cable_details_page_advantage4')))])])]), _vm._v(" "), _c('div', {
    staticClass: "Product-content"
  }, [_c('div', {
    staticClass: "Product-content",
    staticStyle: {
      "background-image": "linear-gradient(120deg, #FFFFFF 0%, #FDFDFD 30%,#E7E8E9 100%)",
      "padding": "10% 0 10% 0"
    }
  }, [_c('Row', {
    staticClass: "max_width",
    staticStyle: {
      "padding": "0 10% 0 10%"
    }
  }, [_c('Col', {
    staticClass: "Product-right",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "md": 12
    }
  }, [_c('ul', {
    staticClass: "Parameter"
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('details_page_product_parameters')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('cable_details_page_product_parameters1')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('cable_details_page_product_parameters2')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('cable_details_page_product_parameters3')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('cable_details_page_product_parameters4')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('cable_details_page_product_parameters5')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('cable_details_page_product_parameters6')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('cable_details_page_product_parameters7')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('cable_details_page_product_parameters8')))])])]), _vm._v(" "), _c('Col', {
    staticClass: "Product-left",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "md": 12
    }
  }, [_c('img', {
    staticClass: "idual-img",
    attrs: {
      "src": require("../../../assets/igo/cable_details.png"),
      "width": "100%"
    }
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "igo-product-details-footer"
  }, [_c('p', {
    staticStyle: {
      "color": "#0084ff"
    }
  }, [_vm._v(_vm._s(_vm.$t('shopping_notes')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('shopping_notes_tip')))]), _vm._v(" "), _c('guess')], 1), _vm._v(" "), _c('BackTop', [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/backtop/top.png")
    }
  }), _vm._v(" "), _c('p', {}, [_vm._v(_vm._s(_vm.$t('top_btn')))])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ifree.ly/support",
      "target": "_blank"
    }
  }, [_c('BackTop', {
    attrs: {
      "height": 100,
      "bottom": 110
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/backtop/service.png")
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Service_btn')))])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06f7a0ce","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDetails/iGO/Cable.vue
// module id = 775
// module chunks = 0